import { Component, OnInit } from '@angular/core';
import { AppMainComponent } from './app.main.component';
import { AppComponent } from '../../app.component';
import { AppMenuItem, AppMenuModel } from '../../domain/menu/app-menu.model';
import { AuthenticationService } from 'src/app/core/auth/auth.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-menu',
  templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit {
  model: AppMenuItem[] = [];

  constructor(
    public appMain: AppMainComponent,
    public app: AppComponent,
    protected translateService: TranslateService,
    private readonly authenticationService: AuthenticationService
  ) {}

  ngOnInit(): void {
    AppMenuModel.menu.forEach(menu => {
      if (menu.roles && this.authenticationService.checkRoles(menu.roles)) {
        this.model.push(menu);
        if (menu.items) {
          const itensComPermissao: AppMenuItem[] = [];
          menu.items.forEach(menuInterno => {
            if (menuInterno.roles && this.authenticationService.checkRoles(menuInterno.roles)) {
              itensComPermissao.push(menuInterno);
            }
          });

          menu.items = itensComPermissao;
        }
      }
      if (menu.dontNeedPermission || (menu.permission && this.authenticationService.checkPermission([menu.permission]))) {
        this.model.push(menu);
      }
    });
  }

  onMenuClick(): void {
    this.appMain.menuClick = true;
  }
}
